const LAZY_LOADING_ERROR_PATTERNS = [
  /Unable to preload CSS for/i,
  /(?:Failed to fetch|error loading) dynamically imported module/i,
  /Importing a module script failed/i,
];

interface ErrorLike {
  name?: unknown;
  message?: unknown;
}

function hasErrorProperties(error: object): error is ErrorLike {
  return 'name' in error || 'message' in error;
}

export function isLazyLoadingError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null || !hasErrorProperties(error)) {
    return false;
  }

  if (error.name === 'ChunkLoadError') {
    return true;
  }

  const message = typeof error.message === 'string' ? error.message : undefined;

  return (
    message !== undefined && LAZY_LOADING_ERROR_PATTERNS.some(pattern => pattern.test(message))
  );
}
